import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon, CheckIcon } from 'lucide-react';
import { tomos } from '../data/content';
import { SectionHeading } from './SectionHeading';
export function Tomos() {
  const [openId, setOpenId] = useState<string>('T1');
  return <section className="bg-cream-50 px-5 py-12 sm:py-20" data-id="element-300" data-mp="1cbb9qsahmjey">
      <div className="mx-auto max-w-4xl" data-id="element-301" data-mp="1r1a4sm6qxeq7">
        <SectionHeading eyebrow="Contenido completo" title="Los 7 Tomos" subtitle="Tu hoja de ruta para que tu perro esté en calma en 21 días" data-id="element-302" data-mp="1r07gmm0t5qdz" />

        <ul className="mt-7 space-y-2 sm:mt-12 sm:space-y-3" data-id="element-303" data-mp="202glav9eapjg">
          {tomos.map(tomo => {
          const isOpen = tomo.id === openId;
          return <li key={tomo.id} className={`overflow-hidden rounded-xl ring-1 ring-inset transition-colors duration-150 ease-out sm:rounded-2xl ${isOpen ? 'bg-cream-100 ring-forest-800/25' : 'bg-cream-50 ring-forest-900/10'}`} data-id="element-304" data-mp="1vyiquxv0m2wq">
                <h3 data-id="element-305" data-mp="39pjko3ghngmy">
                  <button type="button" onClick={() => setOpenId(isOpen ? '' : tomo.id)} aria-expanded={isOpen} aria-controls={`panel-${tomo.id}`} className="flex w-full items-center gap-3 px-3.5 py-3 text-left focus-visible:outline focus-visible:outline-2 focus-visible:-outline-offset-2 focus-visible:outline-forest-700 sm:gap-4 sm:px-6 sm:py-5" data-id="element-306" data-mp="39p1gmknl3y4h">
                    <span className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-md font-display text-[0.7rem] transition-colors duration-150 ease-out sm:h-10 sm:w-10 sm:rounded-lg sm:text-sm ${isOpen ? 'bg-forest-800 text-gold-400' : 'bg-forest-900/[0.06] text-forest-800'}`} style={{
                  fontWeight: 700
                }} data-id="element-307" data-mp="19zuxef10gcn">
                      {tomo.id}
                    </span>
                    <span className="min-w-0 flex-1" data-id="element-308" data-mp="201kupxme2aa3">
                      <span className="block font-display text-[0.95rem] leading-snug text-forest-900 sm:text-lg" style={{
                    fontWeight: 600
                  }} data-id="element-309" data-mp="1vzhi35nzgzn8">
                        {tomo.title}
                      </span>
                      <span className="mt-0.5 block text-[0.72rem] leading-snug text-forest-900/55 sm:text-sm" data-id="element-310" data-mp="2ixu5aay30ipc">
                        {tomo.subtitle}
                      </span>
                    </span>
                    <ChevronDownIcon className={`h-4 w-4 shrink-0 text-forest-800 transition-transform duration-200 ease-out sm:h-5 sm:w-5 ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-311" data-mp="2sndppl1g0kmb" />
                  </button>
                </h3>

                <AnimatePresence initial={false} data-id="element-312" data-mp="2xlp1w2f7n77p">
                  {isOpen ? <motion.div id={`panel-${tomo.id}`} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-313" data-mp="3ha3edpg8w84t">
                      <div className="px-3.5 pb-4 pl-[2.85rem] sm:px-6 sm:pb-6 sm:pl-[5rem]" data-id="element-314" data-mp="2xj81sf6pps5o">
                        <p className="text-[0.8rem] leading-relaxed text-forest-900/75 sm:text-[0.95rem]" data-id="element-315" data-mp="32e5j09e5b7tn">
                          {tomo.description}
                        </p>
                        <ul className="mt-3 flex flex-wrap gap-1.5 sm:mt-4 sm:gap-x-5 sm:gap-y-2" data-id="element-316" data-mp="2tk8yez0mq3gc">
                          {tomo.bullets.map(bullet => <li key={bullet} className="flex items-center gap-1 rounded-full bg-forest-600/10 px-2 py-1 text-[0.68rem] font-medium text-forest-700 sm:bg-transparent sm:px-0 sm:py-0 sm:text-sm" data-id="element-317" data-mp="2jm2xajmnd1cj">
                              <CheckIcon className="h-3 w-3 text-forest-600 sm:h-4 sm:w-4" aria-hidden="true" data-id="element-318" data-mp="3d648fgigwxra" />
                              {bullet}
                            </li>)}
                        </ul>
                      </div>
                    </motion.div> : null}
                </AnimatePresence>
              </li>;
        })}
        </ul>

        <p className="mt-5 text-center text-xs text-forest-900/50 sm:mt-8 sm:text-sm" data-id="element-319" data-mp="2u706erpcg494">
          Tocá cada tomo para ver lo que incluye 👆
        </p>
      </div>
    </section>;
}